import React from 'react';
import SecurityLevels from '../../../../model/SecurityLevels';
import itemIdValue from '../../../itemIdValue';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';
const ConfidentialityLevelSelector = ({ isFullSizeButton = false, className, ...props }) => {
    const t = useT();
    return (<MultiselectFilter classNames={className} isFullSizeButton={isFullSizeButton} itemId={itemIdValue} options={SecurityLevels.Basic} title={t('Confidentiality Level')} {...props}/>);
};
export default ConfidentialityLevelSelector;
